import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { fieldsTimeOutValue } from "components/Field/index";
import PasswordField from "components/Field/PasswordField";
import { uniqueId } from "utils";

const PasswordAndConfirmField = ({
  password,
  setPassword,
  passwordError,
  setPasswordError,
  confirmPassword,
  setConfirmPassword,
  confirmPasswordError,
  setConfirmPasswordError,
  passwordLabelText,
  confirmLabelText,
}) => {
  const id = uniqueId();

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (password !== confirmPassword && confirmPassword?.length > 0) {
        setConfirmPasswordError("Passwords do not match");
      } else {
        setConfirmPasswordError("");
      }
    }, fieldsTimeOutValue);
    return () => clearTimeout(timeOutId);
  }, [password, confirmPassword]);

  return (
    <>
      <PasswordField
        password={password}
        setPassword={setPassword}
        passwordError={passwordError}
        setPasswordError={setPasswordError}
        labelText={passwordLabelText}
      />

      <label
        htmlFor={`${id}_form_field-confirm_password`}
        className="form__field__confirm_password"
      >
        <b>{confirmLabelText || "Confirm Password"}</b>
        <input
          type="password"
          id={`${id}_form_field-confirm_password`}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className={confirmPasswordError && "input__error"}
        />
        <span
          className={`input__error__message ${confirmPasswordError && "show"}`}
        >
          {confirmPasswordError}
        </span>
      </label>
    </>
  );
};

export default PasswordAndConfirmField;

PasswordAndConfirmField.propTypes = {
  password: PropTypes.string.isRequired,
  setPassword: PropTypes.func.isRequired,
  passwordError: PropTypes.string.isRequired,
  setPasswordError: PropTypes.func.isRequired,
  confirmPassword: PropTypes.string.isRequired,
  setConfirmPassword: PropTypes.func.isRequired,
  confirmPasswordError: PropTypes.string.isRequired,
  setConfirmPasswordError: PropTypes.func.isRequired,
  passwordLabelText: PropTypes.string,
  confirmLabelText: PropTypes.string,
};
